import React, { useEffect, useRef } from 'react';
import { Button, ButtonGroup, ModalV2, ModalV2Content, ModalV2Footer } from '@si-armes/dsfr-react';
import PropTypes from 'prop-types';

const ModaleArme = ({ message, modaleOuverte, onClickFunction }) => {
    const dialog = useRef();

    useEffect(() => {
        if (dialog.current) {
            dialog.current.showModal();
        }
    }, [dialog]);
    return (
        <>
            {modaleOuverte && (
                <ModalV2
                    id="modaleConfirmationDemande"
                    idModalTitle="modaleConfirmationDemande-title"
                    onClose={onClickFunction}
                    size="lg"
                    ref={dialog}
                >
                    <ModalV2Content>
                        <p>
                            Votre demande d&apos;ajout d&apos;arme {message} a été transmise à votre
                            préfecture de rattachement et sera traitée dans les meilleurs délais.
                        </p>
                        <p>
                            L&apos;arme apparaîtra dans votre râtelier numérique une fois votre
                            demande validée par la préfecture.
                        </p>
                    </ModalV2Content>
                    <ModalV2Footer>
                        <ButtonGroup align="right" inline>
                            <Button variant="primary" onClick={onClickFunction}>
                                Confirmer l'ajout
                            </Button>
                        </ButtonGroup>
                    </ModalV2Footer>
                </ModalV2>
            )}
        </>
    );
};

ModaleArme.propTypes = {
    message: PropTypes.string,
    modaleOuverte: PropTypes.bool,
    onClickFunction: PropTypes.func,
};

export default ModaleArme;
